import { computedAsync, useAsyncState } from '@vueuse/core'
import { OrganizationsService } from '@itemis-solutions/platform-client-sdk'
import { ref, computed, watch } from 'vue'
import { defineStore } from 'pinia'
import { useRouter } from 'vue-router'

export const useOrganizations = defineStore('Organizations', () => {
  const loadingOrganizations = ref(false)

  const organizations = computedAsync(
    () => OrganizationsService.getOrganizations({}).then((resp) => resp.data),
    [],
    {
      lazy: true,
      evaluating: loadingOrganizations,
    },
  )

  const loadingDefaultOrganization = ref(false)

  const defaultOrganization = computedAsync(
    () =>
      OrganizationsService.getDefaultOrganization({})
        .then((resp) => resp.data)
        .catch((error) => {
          if (error?.status === 409) {
            console.warn('No default organization')
            return null
          }
          throw error
        }),
    null,
    {
      lazy: true,
      evaluating: loadingDefaultOrganization,
    },
  )
  const router = useRouter()

  const currentOrganizationSlug = computed(() => {
    const orgSlug = router?.currentRoute.value?.params?.orgSlug
    if (orgSlug) {
      return String(orgSlug)
    } else {
      return undefined
    }
  })
  const {
    state: currentOrganization,
    isLoading: currentOrganizationLoading,
    error: currentOrganizationError,
    executeImmediate: updateCurrentOrga,
  } = useAsyncState(
    async () => {
      if (currentOrganizationSlug.value) {
        const orga = await OrganizationsService.getOrganization({
          organizationIdOrSlug: currentOrganizationSlug.value,
        })
        return orga.data
      }
      return undefined
    },
    null,
    { immediate: true, resetOnExecute: true },
  )
  watch(currentOrganizationSlug, async () => updateCurrentOrga())

  return {
    loadingOrganizations,
    organizations,
    loadingDefaultOrganization,
    defaultOrganization,
    currentOrganization,
    currentOrganizationError,
    currentOrganizationLoading,
    currentOrganizationSlug,
  }
})
